export default "__VITE_ASSET__CBF$Xdq1__"